import React from "react";
import { StyleSheet, Text, TouchableOpacity, View, Image } from "react-native";
import { colors } from "src/assets";
import { IRequest } from "src/domains";
import { stringDateFullDynamicFormat } from "src/utils/date";
import { checkReviewExpected } from "src/utils/call";
import { Icon } from "src/components";
import { UserStatus } from "src/domains";
import { trim } from "src/utils/string";
import LocalText from "src/local";

type iconProps = {
  color: string;
};

const OutgoingCallIcon = ({ color }: iconProps) => {
  return (
    <svg width="18.064" height="18.049" viewBox="0 0 18.064 18.049">
      <path
        d="M3.9,15.061l-.021.015-.45-.455-.043-.042L2.906,14.1l.022-.02C-.363,10.3-1.394,4.334,2.547.393L2.713.227,5.213,0,8.677,3.464l-.219,2.4-.066.119A3.716,3.716,0,0,1,6.073,7.441,4.13,4.13,0,0,0,7.5,10.568a4.247,4.247,0,0,0,2.955,1.426c.059,0,.114,0,.163-.005a3.714,3.714,0,0,1,1.454-2.317L12.2,9.6l2.4-.218,3.465,3.465-.227,2.5-.166.166a8.58,8.58,0,0,1-6.2,2.533A11.719,11.719,0,0,1,3.9,15.061ZM3.3,1.474c-3.351,3.554-2.149,8.956,1,12.193l.057.058.033.032a10.439,10.439,0,0,0,7.073,3,7.314,7.314,0,0,0,5.12-1.993l.129-1.423-2.606-2.606-1.47.134a3.743,3.743,0,0,0-.869,1.843l-.085.354-.346.112a2.983,2.983,0,0,1-.882.114,5.511,5.511,0,0,1-3.872-1.806c-2.413-2.457-1.73-4.67-1.7-4.762L5,6.375l.354-.085A3.74,3.74,0,0,0,7.2,5.422l.134-1.471L4.725,1.345ZM10.916,6.99a.648.648,0,0,1,0-.916l4.079-4.079L13.987.987,17.282.638l-.341,3.3-1.03-1.03L11.832,6.99a.647.647,0,0,1-.916,0Z"
        fill={color}
      />
    </svg>
  );
};

const CanceledCallIcon = ({ color }: iconProps) => {
  return (
    <svg width="18.064" height="18.049" viewBox="0 0 18.064 18.049">
      <path
        d="M3.9,15.061l-.021.015-.45-.455-.043-.042L2.906,14.1l.022-.021C-.363,10.3-1.394,4.334,2.547.393L2.713.227,5.213,0,8.677,3.464l-.219,2.4-.066.12A3.716,3.716,0,0,1,6.073,7.441,4.13,4.13,0,0,0,7.5,10.568a4.247,4.247,0,0,0,2.955,1.426c.059,0,.114,0,.163-.005a3.716,3.716,0,0,1,1.454-2.317L12.2,9.6l2.4-.218,3.465,3.465-.227,2.5-.166.166a8.58,8.58,0,0,1-6.2,2.533A11.719,11.719,0,0,1,3.9,15.061ZM3.3,1.475c-3.351,3.553-2.149,8.956,1,12.193l.057.058.033.032a10.439,10.439,0,0,0,7.073,3,7.316,7.316,0,0,0,5.12-1.993l.129-1.423-2.606-2.606-1.47.133a3.743,3.743,0,0,0-.869,1.843l-.085.354-.346.112a2.982,2.982,0,0,1-.882.114,5.51,5.51,0,0,1-3.872-1.805c-2.413-2.457-1.73-4.67-1.7-4.763L5,6.376l.354-.085A3.74,3.74,0,0,0,7.2,5.422l.134-1.471L4.725,1.345ZM16.278,6.488l-2-2-2,2a.648.648,0,0,1-.916-.916l2-2-2-2A.648.648,0,0,1,12.27.647l2,2,2-2a.648.648,0,1,1,.916.916l-2,2,2,2a.648.648,0,1,1-.916.916Z"
        transform="translate(0 0)"
        fill={color}
      />
    </svg>
  );
};

const ActiveCallIcon = ({ color }: iconProps) => {
  return (
    <svg width="20" height="20.514" viewBox="0 0 20 20.514">
      <path
        d="M.744,20.514A.744.744,0,0,1,0,19.77V6.844A.744.744,0,0,1,.744,6.1H9.256V2.959H7.62L10.012,0l2.4,2.959H10.744V6.1H19.25a.744.744,0,0,1,.744.744v.6a.745.745,0,0,1,0,.193V19.77a.744.744,0,0,1-.744.744Zm.744-1.488H18.505V9l-8.073,5.833a.744.744,0,0,1-.872,0L1.488,8.991ZM10,13.312l7.922-5.724H10.744v2a.744.744,0,1,1-1.488,0v-2H2.086Z"
        fill={color}
      />
    </svg>
  );
};

const ChevronIcon = ({ color }: iconProps) => {
  return (
    <svg width="5.972" height="10" viewBox="0 0 5.972 10">
      <path
        d="M673.227,1210.877a.887.887,0,0,1,.629.26l4.193,4.193a.889.889,0,0,1,0,1.258l-4.028,4.028a.889.889,0,1,1-1.258-1.257l3.4-3.4-3.564-3.564a.889.889,0,0,1,.629-1.518Z"
        transform="translate(-672.338 -1210.877)"
        fill={color}
      />
    </svg>
  );
};

export type CallHistoryItemProps = {
  cognitoUserId: string;
  item: IRequest;
  color: "white" | "gray" | "transparent";
  onPress?: () => void;
  active?: boolean;
};

enum CallIcon {
  None,
  Outgoing,
  Canceled,
  Active,
}

enum CallState {
  Unknown,
  Active,
  Incoming,
  Outgoing,
  Canceled,
}

export const CallHistoryItem: React.FC<CallHistoryItemProps> = ({
  color,
  cognitoUserId,
  item,
  onPress,
  active,
}) => {
  let avatarStyle = {};
  let selfAvatarStyle = {};
  let containerStyle = {};
  let offerStyle = {};
  let userName: string = "";
  let userImageUrl: string | undefined;
  let selfImageUrl: string | undefined;
  let backgroundColor: string = color === "white" ? colors.white : colors.gray1;
  if (item.sender?.id === cognitoUserId) {
    userName = item.opponent?.name || "Unknown";
    userImageUrl = item.opponent?.image;
    avatarStyle = {
      ...(item.opponent?.status === UserStatus.LOGOUT
        ? {
            borderColor: colors.chokuGray6,
          }
        : {}),
      ...(item.opponent?.status === UserStatus.OFFERABLE
        ? {
            borderColor: colors.chokuGreen,
          }
        : {}),
      ...(item.opponent?.status === UserStatus.ACTIVE
        ? {
            borderColor: colors.orange,
          }
        : {}),
      ...(item.opponent?.status === UserStatus.IN_CALL
        ? {
            borderColor: colors.chokuRed,
          }
        : {}),
    };
    selfImageUrl = item.sender?.image;
    selfAvatarStyle = {
      ...(item.sender?.status === UserStatus.LOGOUT
        ? {
            borderColor: colors.chokuGray6,
          }
        : {}),
      ...(item.sender?.status === UserStatus.OFFERABLE
        ? {
            borderColor: colors.chokuGreen,
          }
        : {}),
      ...(item.sender?.status === UserStatus.ACTIVE
        ? {
            borderColor: colors.orange,
          }
        : {}),
      ...(item.sender?.status === UserStatus.IN_CALL
        ? {
            borderColor: colors.chokuRed,
          }
        : {}),
    };
  } else {
    userName = item.sender?.name || "Unknown";
    userImageUrl = item.sender?.image;
    avatarStyle = {
      ...(item.sender?.status === UserStatus.LOGOUT
        ? {
            borderColor: colors.chokuGray6,
          }
        : {}),
      ...(item.sender?.status === UserStatus.OFFERABLE
        ? {
            borderColor: colors.chokuGreen,
          }
        : {}),
      ...(item.sender?.status === UserStatus.ACTIVE
        ? {
            borderColor: colors.orange,
          }
        : {}),
      ...(item.sender?.status === UserStatus.IN_CALL
        ? {
            borderColor: colors.chokuRed,
          }
        : {}),
    };
    selfImageUrl = item.opponent?.image;
    selfAvatarStyle = {
      ...(item.opponent?.status === UserStatus.LOGOUT
        ? {
            borderColor: colors.chokuGray6,
          }
        : {}),
      ...(item.opponent?.status === UserStatus.OFFERABLE
        ? {
            borderColor: colors.chokuGreen,
          }
        : {}),
      ...(item.opponent?.status === UserStatus.ACTIVE
        ? {
            borderColor: colors.orange,
          }
        : {}),
      ...(item.opponent?.status === UserStatus.IN_CALL
        ? {
            borderColor: colors.chokuRed,
          }
        : {}),
    };
  }

  let callState: CallState = CallState.Unknown;
  let callIcon: CallIcon = CallIcon.None;
  let callIconColor: string = "#C9C9C9";

  if (["WAITING_OPPONENT"].indexOf(item.status) !== -1) {
    callState = CallState.Active;
  } else if (
    [
      "CANCELED_BY_SENDER",
      "REJECTED_BY_OPPONENT",
      "CALL_REJECTED",
      "EXPIRED",
    ].indexOf(item.status) !== -1
  ) {
    callState = CallState.Canceled;
  } else if (item.senderId === cognitoUserId) {
    callState = CallState.Outgoing;
  } else if (item.opponentId === cognitoUserId) {
    callState = CallState.Incoming;
  }

  if (active) {
    callState = CallState.Active;
  }

  if (callState === CallState.Active) {
    callIcon = CallIcon.Active;
    callIconColor = "#0ADFDD";
    backgroundColor = "#C2FCFA";
  } else if (callState === CallState.Canceled) {
    callIcon = CallIcon.Canceled;
    callIconColor = colors.chokuRed;
    offerStyle = { ...offerStyle, color: colors.chokuRed };
  } else if (callState === CallState.Outgoing) {
    callIcon = CallIcon.Outgoing;
  }

  containerStyle = { ...containerStyle, backgroundColor };

  return (
    <TouchableOpacity
      style={[
        {
          flexDirection: "column",
        },
        containerStyle,
      ]}
      onPress={onPress}
    >
      {callState === CallState.Active ? (
        <View
          style={{
            backgroundColor: "#00E5E1",
          }}
        >
          <Text
            style={{
              paddingLeft: 8,
              paddingVertical: 4,
              fontSize: 12,
              fontWeight: "500",
              color: colors.white,
            }}
          >
            {LocalText.screens.callHistoryList.callHistoryItem.activeCall}
          </Text>
        </View>
      ) : null}
      <View
        style={{
          flexDirection: "row",
        }}
      >
        <View
          style={{
            width: 48,
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {callIcon === CallIcon.Active ? (
            <ActiveCallIcon color={callIconColor} />
          ) : null}
          {callIcon === CallIcon.Canceled ? (
            <CanceledCallIcon color={callIconColor} />
          ) : null}
          {callIcon === CallIcon.Outgoing ? (
            <OutgoingCallIcon color={callIconColor} />
          ) : null}
        </View>
        <View
          style={{
            flex: 1,
            paddingVertical: 16,
          }}
        >
          <Text
            style={[
              {
                fontSize: 14,
                fontWeight: "500",
                color: colors.chokuBlack,
                lineHeight: 22,
                flex: 1,
              },
              offerStyle,
            ]}
          >
            {trim(item.service?.title || "", 32, "...")}
          </Text>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              marginTop: 10,
            }}
          >
            {selfImageUrl ? (
              <Image
                style={[styles.avatar, avatarStyle]}
                source={{ uri: selfImageUrl }}
              />
            ) : (
              <View
                style={[styles.avatar, styles.avatarEmpty, selfAvatarStyle]}
              >
                <Icon name={"person"} color={colors.chokuGray5} size={10} />
              </View>
            )}
            <Text
              style={{
                fontSize: 12,
                color: colors.chokuGray5,
                marginLeft: 4,
                marginRight: 4,
              }}
            >
              {cognitoUserId === item.senderId ? "→" : "←"}
            </Text>
            {userImageUrl ? (
              <Image
                style={[styles.avatar, avatarStyle]}
                source={{ uri: userImageUrl }}
              />
            ) : (
              <View style={[styles.avatar, styles.avatarEmpty, avatarStyle]}>
                <Icon name={"person"} color={colors.chokuGray5} size={10} />
              </View>
            )}

            <Text
              style={{
                fontSize: 12,
                color: colors.chokuGray5,
                marginLeft: 8,
                flex: 1,
              }}
            >
              {trim(userName || "", 32, "...")}
              さん
            </Text>
          </View>
        </View>
        <View
          style={{
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: 8,
          }}
        >
          {checkReviewExpected(item, cognitoUserId) ? (
            <Text
              style={{
                fontSize: 12,
                fontWeight: "500",
                color: colors.chokuBlack,
                paddingBottom: 4,
              }}
            >
              {
                LocalText.screens.callHistoryList.callHistoryItem
                  .waitingForReview
              }
            </Text>
          ) : null}
          <Text
            style={{
              fontSize: 12,
              fontWeight: "500",
              color: colors.chokuGray5,
            }}
          >
            {stringDateFullDynamicFormat(item.createdAt)}
          </Text>
        </View>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            width: 30,
          }}
        >
          <ChevronIcon color={"#a5a5a5"} />
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  avatar: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: colors.gray1,
  },
  avatarEmpty: {
    backgroundColor: colors.gray1,
    justifyContent: "center",
    alignItems: "center",
  },
});
